import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../../../ReaduxToolkit/Hooks';
import { VARIABLE_DRAG_TYPE } from '../Canvas/PageCanvas';
import { fetchMasterFields, SectionFields } from '../masterFields';

export default function DynamicVariablePalette() {
  const clientId = useAppSelector((s) => s.FormDesignerUi.clientId);
  const [data, setData] = useState<SectionFields>({});
  const [query, setQuery] = useState('');
  const [collapsed, setCollapsed] = useState<Record<string, boolean>>({});

  useEffect(() => {
    fetchMasterFields(clientId)
      .then(setData)
      .catch((err) => console.error('Error loading master fields:', err));
  }, [clientId]);

  const sections = Object.entries(data)
    .map(([sectionKey, fields]) => {
      const list = Array.isArray(fields) ? fields : [];
      const filtered = list.filter((f) => {
        const name = typeof f === 'object' ? f.field_name : String(f);
        return name.toLowerCase().includes(query.toLowerCase());
      });
      return [sectionKey, filtered] as const;
    })
    .filter(([, fields]) => fields.length > 0);

  return (
    <div className="fd-variable-palette">
      <input
        type="text"
        className="fd-variable-search form-control form-control-sm"
        placeholder="Search fields..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      {sections.map(([sectionKey, fields]) => (
        <div key={sectionKey} className="fd-variable-section">
          <div className="fd-variable-section-title" onClick={() => setCollapsed((s) => ({ ...s, [sectionKey]: !s[sectionKey] }))}>
            {collapsed[sectionKey] ? '▸' : '▾'} {sectionKey}
          </div>
          {!collapsed[sectionKey] && (
            <ul className="fd-variable-list">
              {fields.map((f, i) => {
                const fieldName = typeof f === 'object' ? f.field_name : f;
                const instruction = typeof f === 'object' ? f.instruction : '';
                return (
                  <li
                    key={i}
                    className="fd-variable-item"
                    draggable
                    title={instruction}
                    onDragStart={(e) => {
                      e.dataTransfer.setData(VARIABLE_DRAG_TYPE, JSON.stringify({ fieldKey: fieldName, sectionKey }));
                      e.dataTransfer.effectAllowed = 'copy';
                    }}
                  >
                    &#8226; {fieldName}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      ))}
      {sections.length === 0 && (
        <div className="fd-variable-empty">{clientId ? 'No fields found' : 'Select a client to load its fields'}</div>
      )}
    </div>
  );
}
